import * as React from 'react';

import Table from '~/common/components/Table';
import DropDownButtons from '~/common/controls/DropDownButtons';


export default (props) => {
  const { onClick, editLabel, isProductsEnabled, onGoToProducts, ...rest } = props;

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Site #",
      id: "locationMap",
      accessor: (l) => {
        return l.locationMapping && l.locationMapping.map((m) => m.siteId).join(", ");
      },
    },
    {
      Cell: (row) => {
        const options = [
          {
            onClick: () => onClick(row.original),
            title: editLabel,
          },
          ...(isProductsEnabled ? [{ onClick: () => onGoToProducts(row.original), title: "Show Products" }] : []),
        ];

        return <DropDownButtons options={options} />;
      },
    },
  ];

  return <Table columns={columns} {...rest} />;
};
